<template>
  <view class="login-container" wx:style="{{customStyle}}">
    <view class="login-card-left">
      <view class="login-title"> 请重新登录12306 </view>
      <view class="login-writting"> 当前账号异常，为保证出票，请您重新登录 </view>
    </view>
    <view class="login-button">
      <image
        class="button-icon"
        src="https://img-hxy021.didistatic.com/static/starimg/img/XIAyP8vZRa1693324609097.png"
      />
      <view class="button-writting" bindtap="go12306login">去登录</view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'

  createComponent({
    props: {
      customStyle: {
        type: Object,
        value: ()=>{}
      }
    },
    computed: {},
    methods: {
      go12306login() {
        innerRouter.push(pagePath().LOGIN12306)
      }
    },
  })
</script>

<style scoped lang="stylus">
  .login-container
    display flex
    justify-content space-between
    padding 16px
    background #fff
    border-radius 16px
    margin-top 8px
    .login-card-left
      display flex
      flex-direction column
      .login-title
        display flex
        font-family PingFangSC-Medium
        font-size 16px
        line-height 16px
        color #000
      .login-writting
        margin-top 6px
        font-family PingFangSC-Regular
        font-size 12px
        line-height 12px
        color #666
    .login-button
      height 34px
      display flex
      justify-content center
      align-items center
      border-radius 8px
      background #EDF4FF
      padding 0 8px 0 9px
      .button-icon
        height 16px
        width 16px
      .button-writting
        font-family PingFangSC-Medium
        font-size 14px
        line-height 14px
        color #1473FF  
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {},
  }
</script>